import xhr from '../../tools/xhr.js';
import auth from '../../tools/storage.js';
import mainLenta from './mainLenta.js';
import profileLena from './profileLena.js';

// import bodyMarkupList from '../markup2/mailingAdresseesList.js';
import toolsMarkup from '../../markup/tools.js';

const loaderSpinnerId = 'spinnerMailing';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);


import filmApplicationsForConsider from '../filmApplicationsForConsider.js';


const mainTabPane = document.querySelector('#viewChats');
// const mainTabPaneBTAdd = mainTabPane.querySelector('button[name=add]');
// const mainTabPaneBTTypeDisplay = mainTabPane.querySelector('button[name=typeDataDisplay]');
const mainTabPaneBTReload = mainTabPane.querySelector('button[name=refresh]');
// const mainTabPaneBTDeleteAll = mainTabPane.querySelector('button[name=removeEveryoneToGlobalChat]');
const mainTabPaneBody = mainTabPane.querySelector('div[name=body]');

const mainLentaBody = mainTabPane.querySelector('div[name=body]').querySelector('div[name=mainLenta]');;
const profileLentaBody = mainTabPane.querySelector('div[name=body]').querySelector('div[name=profileLenta]');;
const chatLentaBody = mainTabPane.querySelector('div[name=body]').querySelector('div[name=chatLenta]');;



import chatMarkup from '../../markup2/filmCardChats.js';

const body = document.querySelector('body');

const menuBt =  document.querySelector('#MenuChats');

let nowSending;
let arrFilmManagers;
let infoAboutManager;
let arrChatsWithManager;
let currentFilmManager;
let currentChat;

const getMainData = () => {

  mainLenta.cleanContainer();
  profileLena.cleanContainer();
  mainLenta.drawMarkupInContainer(loaderSpinnerMarkup);

  xhr.request = {
    metod: 'GET',
    url: `festival/${auth.currentFestival}/allChats`,
    data: '',
    callbackSuccess: (answer) => {
      arrFilmManagers = answer.data;
      mainLenta.drawDataInContainer(arrFilmManagers, currentFilmManager);
    }
  };
};

profileLentaBody.addEventListener('click', function (evt) {


  if(evt.target.attributes.filmid){
      // открытие заявки
    filmApplicationsForConsider.loadRequestFilmApplication(evt.target.attributes.filmid.nodeValue);
  } else if (evt.target.attributes.chatid) {
    // console.log(evt.target.attributes.chatid.nodeValue);

 
    openDialog(evt.target.attributes.chatid.nodeValue);
  } 
});

function openDialog(dialogID){
  currentChat = dialogID;
  chatLentaBody.innerHTML = '';
    // chatMarkup.drawDataInContainer([],[],chatLentaBody);

    xhr.request = {
      metod: 'GET',
      url: `festival/${auth.currentFestival}/dialog/${dialogID}`,
      data: '',
      callbackSuccess: (answer) => { 
        console.log(answer);
        chatMarkup.drawDataInContainer([answer.data], [], chatLentaBody , false);
      }
    }
}
mainLentaBody.addEventListener('click', function (evt) {

  if (evt.target.attributes.fmid && evt.target.attributes.fmid.nodeValue != currentFilmManager) {
    // console.log(evt.target.attributes.fmid.nodeValue);
    currentFilmManager = evt.target.attributes.fmid.nodeValue;
    mainLenta.drawDataInContainer(arrFilmManagers, currentFilmManager);
    profileLena.loadContainer( arrFilmManagers.find((element) => element.fmIDfk == currentFilmManager).manager);

    xhr.request = {
      metod: 'GET',
      url: `festival/${auth.currentFestival}/filmManager/${currentFilmManager}/chats`,
      data: '',
      callbackSuccess: (answer) => {
        // console.loaderSpinnerMessage
        if(answer.data.length > 0)
          openDialog(answer.data[0].cffrID);
        
        profileLena.drawChatsInContainer(answer.data, currentChat);
      }
    };
  }
});


export default {

  start() {
    nowSending = false;
    // blockBeforeSening();
    menuBt.addEventListener('click', getMainData);
  },

  redraw: getMainData,

  stop() {
    bodyMarkup.cleanContainer();
  }
};
